import './completed-photo.controller.js';



// WEBPACK FOOTER //
// ./components/projects/project/completed-photo/index.js